// **رموز شاشات التنقّل على الموبايل** — رسمٌ متّجه لكل وجهة في الشريط السفلي والقائمة.
//
// لماذا رسمٌ لا رمزٌ تعبيري (emoji): الرموز التعبيرية تختلف من نظامٍ لآخر وقد لا تُرسم
// أصلًا على ويندوز، وحجمها لا يُضبط بالخطّ. والرسم هنا `currentColor` فيأخذ لون العنصر.
//
// وهي أخُ `toolIcons.tsx` لا بديلُه: ذاك لأدوات شريط الويب، وهذا لشاشات الموبايل —
// وما لم يُعرَّف هنا يُطلب من هناك، فلا رمزَ يُرسم مرّتين.
//
// وكلّها بخطٍّ لا بمساحات مصمتة، وبالسماكة نفسها (1.7) — فلا يبدو رمزٌ أثقل من جاره.
import type { ReactNode } from 'react';
import { toolIcon } from './toolIcons.tsx';

const S = {
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.7, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  className: 'h-full w-full',
  'aria-hidden': true,
};

/** الصفحة الرئيسية — بيت */
const Home = () => (
  <svg {...S}><path d="M3.5 10.5 12 3.8l8.5 6.7V19a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19z" />
    <path d="M9.5 20.5v-6h5v6" /></svg>
);
/** متابعاتي — سمّاعة مكالمة */
const Phone = () => (
  <svg {...S}><path d="M6.5 3.8h3l1.4 3.6-2 1.3a11 11 0 0 0 5.4 5.4l1.3-2 3.6 1.4v3a1.7 1.7 0 0 1-1.9 1.7A15.5 15.5 0 0 1 4.8 5.7 1.7 1.7 0 0 1 6.5 3.8z" /></svg>
);
/** الحجوزات — تذكرة */
const Ticket = () => (
  <svg {...S}><path d="M3.5 8.5V6.8c0-.7.6-1.3 1.3-1.3h14.4c.7 0 1.3.6 1.3 1.3v1.7a2.6 2.6 0 0 0 0 7v1.7c0 .7-.6 1.3-1.3 1.3H4.8c-.7 0-1.3-.6-1.3-1.3v-1.7a2.6 2.6 0 0 0 0-7z" />
    <path d="M14 6.5v2M14 11v2M14 15.5v2" /></svg>
);
/** الرحلات القادمة — طائرة تقلع */
const Departure = () => (
  <svg {...S}><path d="M3 20.5h18" /><path d="M5.2 14.6 3.8 10l1.8.4 1.5 2.1 4.2 1.1L9.6 5.3l2-.5 3.6 7.9 3.6 1a1.6 1.6 0 1 1-.8 3.1L5.9 14.8z" /></svg>
);
/** نشاط الشركة — نبضة */
const Pulse = () => (
  <svg {...S}><path d="M3 12.5h3.6l2-5.5 3.2 11 2.4-7 1.6 3H21" /></svg>
);
/** اللوحة والتقارير — أعمدة على لوحة */
const Dashboard = () => (
  <svg {...S}><rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
    <path d="M8 16v-3.5M12 16V8.5M16 16v-5.5" /></svg>
);
/** تحليل الأداء — خطٌّ صاعد */
const TrendUp = () => (
  <svg {...S}><path d="M3.5 20V4" /><path d="M3.5 20h17" />
    <path d="M7 15.5l3.8-4.2 3 2.4 4.7-5.7" /><path d="M18.5 8h-3.2M18.5 8v3.1" /></svg>
);
/** تقرير التحصيلات — إيصال */
const Receipt = () => (
  <svg {...S}><path d="M6 3.5h12v17l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4-2 1.4z" />
    <path d="M9 8h6M9 11.5h6M9 15h3.5" /></svg>
);
/** الإدارة المالية — ميزان */
const Scale = () => (
  <svg {...S}><path d="M12 4.5v15M7 19.5h10" /><path d="M4 8.5h16M7.5 8 4.5 14h6zM16.5 8l-3 6h6z" /></svg>
);
/** الخزنة — خزنة بقرصٍ ومقبض */
const Vault = () => (
  <svg {...S}><rect x="3.5" y="4" width="17" height="16" rx="2.5" /><circle cx="11" cy="12" r="3.6" />
    <path d="M11 8.4v1M11 15v1M14.6 12h-1M8.4 12h-1" /><path d="M17.5 9.5v5" /></svg>
);
/** خطة العمولات — نسبة في وسام */
const Percent = () => (
  <svg {...S}><circle cx="12" cy="12" r="8.5" /><path d="M9.2 15.2 14.8 8.8" />
    <path d="M9.4 9.4h.01M14.6 14.6h.01" strokeWidth="2.4" /></svg>
);
/** مرتّبي — قسيمة راتب */
const Payslip = () => (
  <svg {...S}><rect x="4" y="3.5" width="16" height="17" rx="2.2" /><path d="M7.5 8h9M7.5 11.5h5" />
    <path d="M14 17.5h2.5M7.5 17.5h3" /></svg>
);
/** حساباتي (الشريك) — حقيبة */
const Briefcase = () => (
  <svg {...S}><rect x="3" y="7" width="18" height="13" rx="2.3" />
    <path d="M9 7V5.3c0-.7.6-1.3 1.3-1.3h3.4c.7 0 1.3.6 1.3 1.3V7" /><path d="M3 12.5h18" /></svg>
);
/** الحضور والانصراف — بصمة */
const Fingerprint = () => (
  <svg {...S}><path d="M7 8.5a6 6 0 0 1 10 4.5" /><path d="M9.5 10.5a3.5 3.5 0 0 1 5 3.2c0 2-.3 3.6-1 5" />
    <path d="M12 12v2.4c0 2.3-.5 4.3-1.4 6" /><path d="M5.5 14c.3-1 .4-2 .4-3a6.1 6.1 0 0 1 .6-2.6" />
    <path d="M17.7 17.5c.5-1.6.8-3.1.8-4.5a6.5 6.5 0 0 0-.4-2.3" /></svg>
);
/** الحضور والإجازات — تقويم بعلامة */
const CalendarCheck = () => (
  <svg {...S}><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" /><path d="M3.5 9.5h17M8 3v4M16 3v4" />
    <path d="m9.2 14.6 1.9 1.9 3.7-3.9" /></svg>
);
/** الموظفين — ثلاثة أشخاص */
const People = () => (
  <svg {...S}><circle cx="9" cy="8.5" r="3.2" /><path d="M3.2 19.5c.9-2.8 3.2-4.3 5.8-4.3s4.9 1.5 5.8 4.3" />
    <path d="M16 5.6a3.2 3.2 0 0 1 0 6" /><path d="M17.2 15.6c1.7.5 3 1.9 3.6 3.9" /></svg>
);
/** ترتيبي — وسام */
const Medal = () => (
  <svg {...S}><circle cx="12" cy="14.5" r="5" /><path d="m9 9.5-2.5-6M15 9.5l2.5-6M8.5 3.5h7" />
    <path d="m12 12.3.9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3z" /></svg>
);
/** قيّمني — نجمة بعلامة صحّ */
const StarCheck = () => (
  <svg {...S}><path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z" />
    <path d="m9.7 12.2 1.7 1.7 3.1-3.3" /></svg>
);
/** تقييم جوجل — نجمة */
const Star = () => (
  <svg {...S}><path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z" /></svg>
);
/** ملاحظاتي — دفتر */
const Notebook = () => (
  <svg {...S}><path d="M7 3.5h11.5v17H7z" /><path d="M7 3.5A2.5 2.5 0 0 0 4.5 6v12A2.5 2.5 0 0 0 7 20.5" />
    <path d="M10 8h5.5M10 12h5.5M10 16h3.5" /></svg>
);
/** شات الفريق — فقاعتا كلام */
const Bubbles = () => (
  <svg {...S}><path d="M4 5.5h10a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H9l-3.5 3V14H4a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2z" />
    <path d="M16 9h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.5v3L15 17h-3.5" /></svg>
);
/** دليلك في السياحة — كتاب مفتوح */
const Book = () => (
  <svg {...S}><path d="M12 6.5C10.4 5 8.3 4.3 5 4.3v13c3.3 0 5.4.7 7 2.2 1.6-1.5 3.7-2.2 7-2.2v-13c-3.3 0-5.4.7-7 2.2z" />
    <path d="M12 6.5v13" /></svg>
);
/** ما لا وجهةَ له — نقطة محايدة */
const Dot = () => (
  <svg {...S}><circle cx="12" cy="12" r="7.5" /><circle cx="12" cy="12" r="2.4" /></svg>
);

const MAP: Record<string, () => ReactNode> = {
  home: Home, crm: Phone, bookings: Ticket, upcoming: Departure, 'admin-crm': Pulse,
  'admin-dashboard': Dashboard, 'admin-analytics': TrendUp, 'admin-payments': Receipt,
  'admin-settlements': Scale, treasury: Vault, commission: Percent,
  'my-payslip': Payslip, 'my-partner-account': Briefcase,
  attendance: Fingerprint, 'admin-attendance': CalendarCheck, 'admin-employees': People,
  'my-rank': Medal, 'evaluate-me': StarCheck, 'google-rating': Star,
  'my-notes': Notebook, guide: Book, 'team-chat': Bubbles,
  declarations: Payslip,   // إقرار مراجعة الطيران (0139): وثيقةٌ تُوقَّع
};

/** رمز الوجهة: من هنا، وإلّا من رموز الأدوات، وإلّا نقطةٌ محايدة — فلا فراغَ في شبكة. */
export function navIcon(id: string): ReactNode {
  const Icon = MAP[id];
  if (Icon) return <Icon />;
  const tool = toolIcon(id);
  if (tool) return <span className="flex h-full w-full items-center justify-center">{tool}</span>;
  return <Dot />;
}
